import React, { useEffect } from 'react';
import TabPageContainer from '~components/atoms/TabPageContainer';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import ProductApprovalTable from './ProductApprovalTable';
import ConfirmUpdateProductStatusModal from './ConfirmUpdateProductStatusModal';
import ProductApprovalTableSearchAndFilterBar from './ProductApprovalSearchAndFilterBar';
import ProductApprovalTablePaginator from './ProductApprovalPagination';

const ProductApproval = () => {
    const dispatch = useAppDispatch();

    const productListingIndex = useAppSelector(state => state.approval.pendingProductListing.index);

    useEffect(() => {
        dispatch(combinedActions.approvalGetPendingProductListingAttempt());
    }, [productListingIndex]);

    return (
        <TabPageContainer>
            <ProductApprovalTableSearchAndFilterBar/>

            <ProductApprovalTable />

            <ProductApprovalTablePaginator />

            <ConfirmUpdateProductStatusModal />
        </TabPageContainer>
    );
};

export default ProductApproval;
